// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"modal-body__modal-body___u6N5F"};